import React from "react";
import { DoPopupContainer } from "./popupTableHelper";
import ReactDOMServer from "react-dom/server";
import { calculateCumulPluie } from "../../helper";
import { calculRoundValue, getColor, getMeasureValue, Grey, logo } from "./popupHelper";
import { formatDate } from "../view/detailsHelper";
import { DoTpPopupApi, EventsPluieApi } from "../../api";

export const getInfoDo = async (feature) => {
  let TDeversementColor = Grey;
  let NbDeversementColor = Grey;
  let VolumeColor = Grey;
  let NbDeversement = 'NR';
  let TDeversement = 'NR';
  let VDeversement = 'NR';
  let CumulPluie = 'NR';
  let content = document.createElement('div');
  let attributes = feature.graphic.attributes;
  const categoriesOnly =
    attributes.Color !== 'NOIR' && attributes.Color !== 'GRIS';
  const dateRemontee =
    attributes.Color !== 'NOIR' && attributes.Color !== 'GRIS'
      ? attributes.RecordDate
      : 'Pas de télégestion';

  try {
    const getMeasures = categoriesOnly && DoTpPopupApi.getMeasure(
        attributes.Code,
        formatDate(attributes.RecordDate),
      );
    const getPluvio = categoriesOnly && DoTpPopupApi.getPluvio(
        attributes.Code,
        formatDate(attributes.RecordDate),
      );
    const povInfo = EventsPluieApi.getInstallPov(attributes.Code);
    const [measureData, pluvioData, povValue] = await Promise.allSettled([getMeasures, getPluvio, povInfo]);
      
    let installValue, pluvioValue;
    if (measureData.status === 'fulfilled' && measureData.value) {
        installValue = measureData.value.data;
        installValue.forEach((element: any) => {
            const calculRound = calculRoundValue(element.measure);
      
            switch (element.variableType) {
              case 'TDEVDO':
                TDeversement = `${Math.round(100 * element.measure) / 100}h`;
                TDeversementColor = getColor(attributes.Color);
                break;
      
              case 'NBDEVDO':
                NbDeversement = getMeasureValue(calculRound, element.measure).toString();
                NbDeversementColor = getColor(attributes.Color);
                break;
      
              case 'VDEVDO':
                VDeversement = getMeasureValue(calculRound, element.measure).toString();
                VolumeColor = getColor(attributes.Color);
                break;
      
              default:
                break;
            }
        });
    }    

    if(pluvioData.status === 'fulfilled' && pluvioData.value) {
        pluvioValue = pluvioData.value.data;
        if (pluvioValue && pluvioValue[0]) {
          CumulPluie = calculateCumulPluie(pluvioValue);
        }
    }

    let idPov = 'NR';
    if (povValue.status === 'fulfilled' && povValue.value) {
      idPov = povValue.value.data;
    }

    content.innerHTML = ReactDOMServer.renderToString(
      <DoPopupContainer
        title={attributes.Description}
        // titleValue={titleValue}
        tableElements={{
          'Cumul pluie': CumulPluie,
          'Temps déversement': TDeversement,
          'Nombre déversements': NbDeversement,
          'Volume déversé': VDeversement,
          'POV': idPov,
        }}
        elements={{
          Temps: TDeversementColor,
          Volume: VolumeColor,
          Nombre: NbDeversementColor,
        }}
        dateRemontee={dateRemontee}
        icon={logo}
      />
    );
  } catch (error) {
    console.log(error);
  }
  return content;
};

export const getInfoTp = async (feature) => {
  let TDeversementColor = Grey;
  let NbDeversementColor = Grey;
  let VolumeColor = Grey;
  let NbDeversement = 'NR';
  let TDeversement = 'NR';
  let VDeversement = 'NR';
  let CumulPluie = 'NR';
  let content = document.createElement('div');
  let attributes = feature.graphic.attributes;
  const categoriesOnly =
    attributes.Color !== 'NOIR' && attributes.Color !== 'GRIS';
  const dateRemontee = categoriesOnly
    ? attributes.RecordDate
    : 'Pas de télégestion';

  try {
    const getMeasures = categoriesOnly && DoTpPopupApi.getMeasure(
        attributes.Code,
        formatDate(attributes.RecordDate),
      );
    const getPluvio = categoriesOnly && DoTpPopupApi.getPluvio(
        attributes.Code,
        formatDate(attributes.RecordDate),
      );
    const povInfo = categoriesOnly && EventsPluieApi.getInstallPov(attributes.Code);
    const [measureData, pluvioData, povValue] = await Promise.allSettled([getMeasures, getPluvio, povInfo]);

    let installValue, pluvioValue;
    if (measureData.status === 'fulfilled' && measureData.value) {
        installValue = measureData.value.data;
        if (installValue) {
            // Parcourir les valeurs pour extraire les informations nécessaires
            installValue.forEach((element: any) => {
              const calculRound = calculRoundValue(element.measure);
      
              switch (element.variableType) {
                case 'TDEBPR':
                case 'TDEBTP':
                  if (element.colorLabel !== null) {
                    TDeversement = `${Math.round(100 * element.measure) / 100}h`;
                    TDeversementColor = getColor(element.colorLabel);
                  }
                  break;
      
                case 'NDEBPR':
                case 'NDEBTP':
                  if (element.colorLabel !== null) {
                    NbDeversement = getMeasureValue(calculRound, element.measure).toString();
                    NbDeversementColor = getColor(element.colorLabel);
                  }
                  break;
      
                case 'VDEBPR':
                case 'VDEBTP':
                  if (element.colorLabel !== null) {
                    VDeversement = getMeasureValue(calculRound, element.measure).toString();
                    VolumeColor = getColor(element.colorLabel);
                  }
                  break;
      
                default:
                  break;
              }
            });
          }
    }

    if (pluvioData.status === 'fulfilled' && pluvioData.value) {
        pluvioValue = pluvioData.value.data;
        if (pluvioValue && pluvioValue[0]) {
          CumulPluie = calculateCumulPluie(pluvioValue);
        }
    }

    let idPov = 'NR';
    if (povValue.status === 'fulfilled' && povValue.value) {
      idPov = povValue.value.data;
    }

    content.innerHTML = ReactDOMServer.renderToString(
        <DoPopupContainer
          title={attributes.Description}
          tableElements={{
            'Cumul pluie': CumulPluie,
            'Temps déversement': TDeversement,
            'Nombre déversements': NbDeversement,
            'Volume déversés': VDeversement,
            'POV': idPov,
          }}
          elements={{
            Temps: TDeversementColor,
            Volume: VolumeColor,
            Nombre: NbDeversementColor,
          }}
          dateRemontee={dateRemontee}
          icon={logo}
        />
    );
  } catch (error) {
    console.log(error);
  }
  return content;
};